export default __webpack_public_path__ + "static/media/login_bg_hg@3x.f3a9d381.jpg";